// @ts-nocheck
import {createStyles, makeStyles} from '@material-ui/core/styles';
import {getDirectionStyles} from '../../../utils/ThemeUtils';

const RIGHT_ROUNDED_BORDER = '0 18px 18px 0';
const LEFT_ROUNDED_BORDER = '18px 0 0 18px';

const useStyles = makeStyles(({palette, typography, breakpoints, direction}) =>
    createStyles({
        paper: {
            backgroundColor: palette.background.overlays,
            "& [class*='MuiPickersBasePicker-pickerView']": {
                justifyContent: 'flex-start',
                maxWidth: 'unset'
            }
        },
        dayWrapper: {
            position: 'relative'
        },
        day: {
            width: 36,
            height: 36,
            fontSize: typography.caption.fontSize,
            margin: '0 2px',
            color: 'inherit',
            zIndex: 99
        },
        customDayHighlight: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: '2px',
            right: '2px',
            border: `1px solid ${palette.secondary.main}`,
            borderRadius: '50%'
        },
        nonCurrentMonthDay: {
            color: palette.background.overlays,
            cursor: 'auto !important',
            '&:hover': {
                background: 'transparent'
            }
        },
        disabledFutureDay: {
            color: palette.dividerStrong,
            cursor: 'auto !important',
            '&:hover': {
                background: 'transparent'
            }
        },
        highlightNonCurrentMonthDay: {
            color: palette.secondary.main
        },
        emphasis: {
            background: `${palette.primary.main} !important`,
            '&:hover': {
                background: `${palette.action.active} !important`
            }
        },
        preselectedEmphasis: {
            background: `${palette.calendar.preselectedFirst.main} !important`,
            '&:hover': {
                background: `${palette.action.active} !important`
            }
        },
        inactiveEmphasis: {
            border: `1px solid ${palette.action.active} !important`,
            color: palette.text.primary
        },
        inactiveFutureEmphasis: {
            border: `1px solid ${palette.action.selected} !important`,
            color: palette.text.disabled,
            '&:hover': {
                background: 'transparent'
            }
        },
        highlight: {
            display: 'flex',
            background: palette.calendar.selected.main,
            color: palette.text.primary,
            '&::before': {
                content: getDirectionStyles(direction)('', '""'),
                display: 'block',
                position: 'absolute',
                width: '25%',
                height: 36,
                transform: 'translateX(40%)',
                background: palette.calendar.selected.main
            },
            '&::after': {
                content: getDirectionStyles(direction)('""', ''),
                display: 'block',
                position: 'absolute',
                width: '25%',
                height: 36,
                transform: 'translateX(-40%)',
                background: palette.calendar.selected.main
            }
        },
        activeHighlight: {
            background: palette.calendar.selected.main,
            color: palette.text.primary,
            borderRadius: '50%'
        },
        firstHighlight: {
            display: 'flex',
            background: palette.calendar.selected.main,
            color: palette.text.primary,
            borderRadius: getDirectionStyles(direction)(LEFT_ROUNDED_BORDER, RIGHT_ROUNDED_BORDER),
            '&::before': {
                content: getDirectionStyles(direction)('', '""'),
                display: 'block',
                position: 'absolute',
                width: 35,
                height: 36,
                transform: 'translateX(-30px)',
                background: palette.calendar.selected.main,

                [breakpoints.up('sm')]: {
                    width: 60
                },

                [breakpoints.up('fmd')]: {
                    width: 30
                }
            },
            '&::after': {
                content: getDirectionStyles(direction)('""', ''),
                display: 'block',
                position: 'absolute',
                width: 35,
                height: 36,
                transform: 'translateX(30px)',
                background: palette.calendar.selected.main,

                [breakpoints.up('sm')]: {
                    width: 60
                },

                [breakpoints.up('fmd')]: {
                    width: 30
                }
            }
        },
        lastHighlight: {
            background: palette.calendar.selected.main,
            color: palette.text.primary,
            borderRadius: getDirectionStyles(direction)(RIGHT_ROUNDED_BORDER, LEFT_ROUNDED_BORDER),
            '&::before': {
                content: getDirectionStyles(direction)('', '""'),
                position: 'absolute',
                width: 25,
                height: 36,
                transform: 'translateX(25px)',
                background: palette.calendar.selected.main,

                [breakpoints.up('sm')]: {
                    width: 60,
                    transform: 'translateX(60px)'
                },

                [breakpoints.up('fmd')]: {
                    width: 20,
                    transform: 'translateX(20px)'
                }
            },
            '&::after': {
                content: getDirectionStyles(direction)('""', ''),
                position: 'absolute',
                width: 25,
                height: 36,
                transform: 'translateX(-55px)',
                background: palette.calendar.selected.main,

                [breakpoints.up('sm')]: {
                    width: 60,
                    transform: 'translateX(-90px)'
                },

                [breakpoints.up('fmd')]: {
                    width: 20,
                    transform: 'translateX(-50px)'
                }
            }
        },
        lastWeekDayHighlight: {
            background: palette.calendar.selected.main,
            color: palette.text.primary,
            borderRadius: getDirectionStyles(direction)(RIGHT_ROUNDED_BORDER, LEFT_ROUNDED_BORDER),
            '&::before': {
                content: getDirectionStyles(direction)('', '""'),
                position: 'absolute',
                width: 50,
                height: 36,
                transform: 'translateX(40px)',
                background: palette.calendar.selected.main
            },
            '&::after': {
                content: getDirectionStyles(direction)('""', ''),
                position: 'absolute',
                width: 50,
                height: 36,
                borderRadius: RIGHT_ROUNDED_BORDER,
                transform: 'translateX(-40px)',
                background: palette.calendar.selected.main
            }
        },
        firstSundayHighlight: {
            background: palette.calendar.selected.main,
            color: palette.text.primary,
            borderRadius: getDirectionStyles(direction)('0 18px 0 0', '18px 0 0 0'),
            '&::before': {
                content: getDirectionStyles(direction)('', '""'),
                position: 'absolute',
                width: 50,
                height: 36,
                transform: 'translateX(40px)',
                background: palette.calendar.selected.main
            },
            '&::after': {
                content: getDirectionStyles(direction)('""', ''),
                position: 'absolute',
                width: 50,
                height: 36,
                borderTopRightRadius: 18,
                transform: 'translateX(-40px)',
                background: palette.calendar.selected.main
            }
        },
        middleSundayHighlight: {
            background: palette.calendar.selected.main,
            color: palette.text.primary,
            '&::before': {
                content: getDirectionStyles(direction)('', '""'),
                position: 'absolute',
                width: 50,
                height: 36,
                transform: 'translateX(40px)',
                background: palette.calendar.selected.main
            },
            '&::after': {
                content: getDirectionStyles(direction)('""', ''),
                position: 'absolute',
                width: 50,
                height: 36,
                transform: 'translateX(-40px)',
                background: palette.calendar.selected.main
            }
        },
        lastSundayHighlight: {
            background: palette.calendar.selected.main,
            color: palette.text.primary,
            borderRadius: getDirectionStyles(direction)('0 0 18px  0', '0 0 0 18px'),
            '&::before': {
                content: getDirectionStyles(direction)('', '""'),
                position: 'absolute',
                width: 50,
                height: 36,
                transform: 'translateX(40px)',
                background: palette.calendar.selected.main
            },
            '&::after': {
                content: getDirectionStyles(direction)('""', ''),
                position: 'absolute',
                width: 50,
                height: 36,
                borderBottomRightRadius: 18,
                transform: 'translateX(-40px)',
                background: palette.calendar.selected.main
            }
        },
        preselectedHighlight: {
            display: 'flex',
            background: palette.calendar.preselected.main,
            color: palette.text.primary,
            '&::before': {
                content: getDirectionStyles(direction)('', '""'),
                display: 'block',
                position: 'absolute',
                width: '25%',
                height: 36,
                transform: 'translateX(40%)',
                background: palette.calendar.preselected.main
            },
            '&::after': {
                content: getDirectionStyles(direction)('""', ''),
                display: 'block',
                position: 'absolute',
                width: '25%',
                height: 36,
                transform: 'translateX(-40%)',
                background: palette.calendar.preselected.main
            }
        },
        preselectedActiveHighlight: {
            background: palette.calendar.preselected.main,
            color: palette.text.primary,
            borderRadius: '50%'
        },
        preselectedFirstHighlight: {
            display: 'flex',
            background: palette.calendar.preselected.main,
            color: palette.text.primary,
            borderRadius: getDirectionStyles(direction)(LEFT_ROUNDED_BORDER, RIGHT_ROUNDED_BORDER),
            '&::before': {
                content: getDirectionStyles(direction)('', '""'),
                display: 'block',
                position: 'absolute',
                width: 35,
                height: 36,
                transform: 'translateX(-30px)',
                background: palette.calendar.preselected.main,

                [breakpoints.up('sm')]: {
                    width: 60
                },

                [breakpoints.up('fmd')]: {
                    width: 30
                }
            },
            '&::after': {
                content: getDirectionStyles(direction)('""', ''),
                display: 'block',
                position: 'absolute',
                width: 35,
                height: 36,
                transform: 'translateX(30px)',
                background: palette.calendar.preselected.main,

                [breakpoints.up('sm')]: {
                    width: 60
                },

                [breakpoints.up('fmd')]: {
                    width: 30
                }
            }
        },
        preselectedLastHighlight: {
            background: palette.calendar.preselected.main,
            color: palette.text.primary,
            borderRadius: getDirectionStyles(direction)(RIGHT_ROUNDED_BORDER, LEFT_ROUNDED_BORDER),
            '&::before': {
                content: getDirectionStyles(direction)('', '""'),
                position: 'absolute',
                width: 25,
                height: 36,
                transform: 'translateX(25px)',
                background: palette.calendar.preselected.main,

                [breakpoints.up('sm')]: {
                    width: 60,
                    transform: 'translateX(60px)'
                },

                [breakpoints.up('fmd')]: {
                    width: 20,
                    transform: 'translateX(20px)'
                }
            },
            '&::after': {
                content: getDirectionStyles(direction)('""', ''),
                position: 'absolute',
                width: 25,
                height: 36,
                transform: 'translateX(-55px)',
                background: palette.calendar.preselected.main,

                [breakpoints.up('sm')]: {
                    width: 60,
                    transform: 'translateX(-90px)'
                },

                [breakpoints.up('fmd')]: {
                    width: 20,
                    transform: 'translateX(-50px)'
                }
            }
        }
    })
);

export {useStyles};
